import { supabase } from '../../lib/supabase';

const PRICE_IDS = {
  monthly: import.meta.env.VITE_STRIPE_PRICE_MONTHLY as string,
  lifetime: import.meta.env.VITE_STRIPE_PRICE_LIFETIME as string,
};

const FOUNDING_COUPON = import.meta.env.VITE_STRIPE_FOUNDING_COUPON as string;

export const subscriptionService = {
  get foundingCoupon(): string {
    return FOUNDING_COUPON;
  },

  async createCheckoutSession(plan: 'monthly' | 'lifetime', couponId?: string): Promise<string> {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) throw new Error('Not authenticated');

    const priceId = PRICE_IDS[plan];
    if (!priceId) throw new Error(`Price ID not configured for plan: ${plan}`);

    const origin = window.location.origin;

    const { data, error } = await supabase.functions.invoke('create-checkout-session', {
      body: {
        priceId,
        userId: user.id,
        couponId: couponId ?? null,
        mode: plan === 'monthly' ? 'subscription' : 'payment',
        successUrl: `${origin}?checkout=success`,
        cancelUrl: `${origin}?checkout=cancel`,
      },
    });

    if (error) throw new Error(error.message);
    if (!data?.url) throw new Error('No checkout URL returned');

    return data.url as string;
  },
};
